import { autoinject, bindable } from 'aurelia-framework';
import { AsyncErrorHandler } from 'lib/ui';
import { PenOfferScopeDto } from 'models/pen/PenOfferScope';
import { PenOfferScopeService } from 'services/pen/pen-offer-scope-service';
import { ToastService } from 'services/toast-service';

@autoinject
export class PenOfferScopeContainer {
  @bindable
  protected penOfferScopeId: number;

  protected penOfferScope: PenOfferScopeDto;

  constructor(private penOfferScopeService: PenOfferScopeService, private toastService: ToastService) {}

  async attached() {
    const response = await this.penOfferScopeService.getPenOfferScope(this.penOfferScopeId);
    this.penOfferScope = response.data;
  }

  @AsyncErrorHandler
  async save() {
    await this.penOfferScopeService.updatePenOfferScope(this.penOfferScope.Id, this.penOfferScope);
    this.toastService.showSuccess('pens.penOfferScope.updated');
  }
}
